import getFacetApiPath from "./getFacetApiPath";

const getFacetApiUrl = ({ facetId, lang, channel }) =>
  `${getFacetApiPath()}?facetIds=${facetId}&lang=${lang}&channel=${channel}`;

export default getFacetApiUrl;
